import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["sidebar", "overlay"]
    static classes = ["mobileHidden", "overlayHidden"]
        

    connect() {
        console.log("User controller connected!");
        
        this.mobileBreakpoint = 1024;
        this.handleMobileState();
        window.addEventListener('resize', this.handleResize);
    }

    disconnect() {
        window.removeEventListener('resize', this.handleResize);
    }

    open() {
        this.sidebarTarget.classList.remove(this.mobileHiddenClass);
        this.overlayTarget.classList.remove(this.overlayHiddenClass);
    }

    close() {
        this.sidebarTarget.classList.add(this.mobileHiddenClass);
        this.overlayTarget.classList.add(this.overlayHiddenClass);
    }

    handleResize = () => {
        this.handleMobileState();
    }

    handleMobileState() {
        if (window.innerWidth >= this.mobileBreakpoint) {
        // Desktop: Ensure sidebar is visible and overlay is hidden
        this.sidebarTarget.classList.remove(this.mobileHiddenClass);
        this.overlayTarget.classList.add(this.overlayHiddenClass);
        } else {
        // Mobile: Ensure sidebar starts hidden
        this.sidebarTarget.classList.add(this.mobileHiddenClass);
        // Ensure overlay starts hidden (it's shown by the 'open' action)
        this.overlayTarget.classList.add(this.overlayHiddenClass);
        }
    }

    get mobileHiddenClass() {
      // Access the value directly from the data map, not by calling the getter itself (this.mobileHiddenClass)
      // Stimulus makes data attributes available via this.data.get()
      return this.data.get("mobile-hidden") || "hidden-mobile";
    }

    get overlayHiddenClass() {
      return this.data.get("overlay-hidden") || "hidden";
    }
}